import { createSlice } from "@reduxjs/toolkit";

const initialLogsFilter = {};

const initialState = {
    submitted: false,
    isLoading: false,
    disabled: false,
    tasks: [],
    errorMessage: null,
    successMessage: null,
    advancedFilterModal: false,
    taskDetailsModal: false,
    detailedTask: null,
    taskLogs: [],
    taskLogsLoading: null,
    taskLogsError: null,
    cancelModal: false,
    cancelLoading: false,
    cancellationErrorMessage: null,
    taskToCancel: null,
    totalTasks: 0,
    totalLogs: 0,
    taskLogsRefreshing: false,
    availableClients: [],
    detailedTaskError: null,
    initialLogsFilter: initialLogsFilter,
    taskSubTypes: null,
};

const taskManagerSlice = createSlice({
    name: "TaskManager",
    initialState,
    reducers: {
        getAllTasksRequest(state) {
            state.isLoading = true;
            state.tasks = [];
            state.errorMessage = null;
        },
        getAllTasksSuccess(state, action) {
            state.isLoading = false;
            state.tasks = action.payload.content;
            state.totalTasks = action.payload.totalElements;
            state.errorMessage = null;
            state.advancedFilterModal = false;
        },
        getAllTasksFailure(state, action) {
            state.isLoading = false;
            state.tasks = [];
            state.errorMessage = action.payload;
        },
        toggleAdvancedFilter(state) {
            state.advancedFilterModal = !state.advancedFilterModal;
        },
        toggleTaskDetails(state) {
            state.taskDetailsModal = !state.taskDetailsModal;
        },
        getTaskLogsRequest(state) {
            state.taskLogs = [];
            state.taskLogsLoading = true;
            state.taskLogsError = null;
        },
        refreshTaskLogsRequest(state) {
            state.taskLogsRefreshing = true;
            state.taskLogsError = null;
        },
        getTaskLogsSuccess(state, action) {
            state.taskLogs = action.payload.content;
            state.taskLogsLoading = false;
            state.totalLogs = action.payload.totalElements;
            state.taskLogsRefreshing = false;
            state.taskLogsError = null;
        },
        getTaskLogsFailure(state, action) {
            state.taskLogsLoading = false;
            state.taskLogsRefreshing = false;
            state.taskLogsError = action.payload;
        },
        getDetailedTaskRequest(state, action) {
            state.detailedTask = action.payload;
            state.detailedTaskLoading = true;
            state.detailedTaskError = null;
        },
        refreshDetailedTaskRequest(state) {
            state.detailedTaskRefreshing = true;
            state.detailedTaskError = null;
        },
        getDetailedTaskSuccess(state, action) {
            state.detailedTask = action.payload;
            state.detailedTaskLoading = false;
            state.detailedTaskRefreshing = false;
            state.detailedTaskError = null;
            state.initialLogsFilter = {
                page: 0,
                taskIdentifier: action.payload.externalUUID,
            };
        },
        refreshDetailedTaskSuccess(state, action) {
            state.detailedTask = action.payload;
            state.detailedTaskLoading = false;
            state.detailedTaskRefreshing = false;
            state.detailedTaskError = null;
        },
        getDetailedTaskFailure(state, action) {
            state.detailedTask = null;
            state.detailedTaskLoading = false;
            state.detailedTaskRefreshing = false;
            state.detailedTaskError = action.payload;
        },
        toggleCancelTask(state) {
            state.cancelModal = !state.cancelModal;
        },
        addTaskToCancel(state, action) {
            state.taskToCancel = action.payload;
        },
        cancelTaskRequest(state) {
            state.cancelLoading = true;
            state.cancellationErrorMessage = null;
        },
        cancelTaskSuccess(state, action) {
            state.cancelLoading = false;
            state.cancellationErrorMessage = null;
            state.taskToCancel = null;
            state.successMessage = action.payload.successMessage;
            state.cancelModal = false;
        },
        cancelTaskFailure(state, action) {
            state.cancelLoading = false;
            state.cancellationErrorMessage = action.payload;
            state.cancelModal = false;
        },
        emptyFilterError(state, action) {
            state.errorMessage = action.payload;
        },
        clearEmptyFilterError(state) {
            state.errorMessage = null;
        },
        clearErrorMessages(state) {
            state.errorMessage = null;
            state.cancellationErrorMessage = null;
            state.successMessage = null;
            state.taskLogsError = null;
            state.detailedTaskError = null;
        },
        setAvailableClients(state, action) {
            state.availableClients = action.payload;
        },
        updateClientsRequest(state) {
            state.clientsLoading = true;
            state.availableClients = [];
        },
        updateClientsSuccess(state, action) {
            state.clientsLoading = false;
            state.availableClients = action.payload;
        },
        updateClientsFailure(state, action) {
            state.clientsLoading = false;
            state.availableClients = [];
            state.errorMessage = action.payload;
        },
        setTaskSubTypes(state, action) {
            state.taskSubTypes = action.payload;
        },
    },
});

export default taskManagerSlice;
